<template>
  <div class="chat-cont" @scroll="scrollLaod" ref="visitorchatBody" v-viewer="viewerOption">
    <!-- 历史聊天记录 -->
    <template v-for="(item, i) in historyList">
      <template v-if="item.groupId === groupId || historyServicesIds.includes(item.serviceId)">
        <div  :key="i" v-if="(item.belong === 'agent' || item.belong === 'monitor') && !(config.withdraw !== '1' && item.status === -1) && (item.display === 'all' || item.display === 'visitor')" class="chat-list">
          <div class="service-send-time">
            {{item.sendTime}}
          </div>
          <div class="customerMessage" style="margin-top: 0">
            <div class="avatar">
              <img style="width: 100%;height: 100%;" class="visitor-img" :src="item.senderPicture ? item.senderPicture : require('@/assets/img/customer-img.png')"/>
            </div>
            <div class="cont">
              <div class="name">{{item.senderName}}</div>
              <template v-if="item.status === -1">
                <div class="message-cont">{{$t('withDrawned')}}</div>
              </template>
              <template v-if="item.status !== -1">
                <msg-content :item="item"></msg-content>
              </template>
            </div>
            <img v-if="(item.belong === 'visitor' || item.belong === 'agent') && item.status !== -1" @click="handleMessageReference(item)" class="icon-reference" :src="require('@/assets/img/icon-reference.svg')"/>
          </div>
        </div>
        <div :key="i" class="chat-list" v-else-if="item.belong === 'visitor'">
          <div class="visitor-send-time">
            {{item.sendTime}}
          </div>
          <div class="serviceMessage" style="margin-top: 0">
            <div class="avatar">
              <img style="width:100%; height:100%" class="visitor-img" :src="config.headPicture ? config.headPicture : require('@/assets/img/icon-img/visitor-avatar.png')"/>
            </div>
            <div class="cont">
              <msg-content :item="item"></msg-content>
            </div>
            <img v-if="(item.belong === 'visitor' || item.belong === 'agent') && item.status !== -1" @click="handleMessageReference(item)" class="icon-reference" :src="require('@/assets/img/icon-reference.svg')"/>
          </div>
        </div>
        <div :key="i" v-else-if="item.belong === 'system' || item.category === 'EVENT' " class="customerMessage">
          <div class="avatar">
            <img style="width: 100%; height: 100%" class="visitor-img" :src="config.servicePicture ? config.servicePicture : require('@/assets/img/customer-img.png')"/>
          </div>
          <div class="cont">
            <div class="name">{{$t('serviceSys')}}</div>
            <msg-content :item="item"></msg-content>
          </div>
          <img v-if="(item.belong === 'visitor' || item.belong === 'agent') && item.status !== -1" @click="handleMessageReference(item)" class="icon-reference" :src="require('@/assets/img/icon-reference.svg')"/>
        </div>
      </template>
    </template>
    <div class="divider" v-if="historyList.length > 0"></div>
    <!-- 排队 -->
    <!-- 实时聊天记录 -->
    <template v-for="(item, i) in chatList">
      <template v-if="!visitorStatus || (item.groupId === groupId || (item.serviceId === serviceId && serviceId))">
        <div v-if="(item.belong === 'agent' || item.belong === 'monitor') && !(config.withdraw !== '1' && item.status === -1) && (item.display === 'all' || item.display === 'visitor')" :data-id="item.messageId" class="chat-list inService-agent">
          <div class="service-send-time">
            {{item.sendTime}}
          </div>
          <div class="customerMessage" style="margin-top: 0">
            <div class="avatar">
              <img style="width: 100%;height: 100%" class="visitor-img" :src="item.senderPicture ? item.senderPicture : require('@/assets/img/customer-img.png')"/>
            </div>
            <div class="cont">
              <div class="name">{{item.senderName}}</div>
              <template v-if="item.status === -1">
                <div class="message-cont">{{$t('withDrawned')}}</div>
              </template>
              <template v-if="item.status !== -1">
                <msg-content :item="item"></msg-content>
              </template>
            </div>
            <img v-if="(item.belong === 'visitor' || item.belong === 'agent') && item.status !== -1" @click="handleMessageReference(item)" class="icon-reference" :src="require('@/assets/img/icon-reference.svg')"/>
          </div>
        </div>
        <div class="chat-list" v-else-if="item.belong === 'visitor'">
          <div class="visitor-send-time">
            {{item.sendTime}}
          </div>
          <div class="serviceMessage" style="margin-top: 0">
            <div class="avatar">
              <img style="width:100%; height:100%" class="visitor-img" :src="config.headPicture ? config.headPicture : require('@/assets/img/icon-img/visitor-avatar.png')"/>
            </div>
            <div class="cont">
              <msg-content :item="item"></msg-content>
              <div class="have-read" v-if="config.alreadyRead === '1'">
                <template v-if="item.status === 1" >{{$t('haveread')}}</template>
                <template v-if="item.status === 0" >{{$t('unread')}}</template>
              </div>
            </div>
            <img v-if="(item.belong === 'visitor' || item.belong === 'agent') && item.status !== -1" @click="handleMessageReference(item)" class="icon-reference" :src="require('@/assets/img/icon-reference.svg')"/>
            <!-- <div v-show="config.withdraw === '1' && item.status === -1" class="already-withdraw">已撤回</div>
            <div @click="withdraw(item)" class="withdraw">
              <a-icon type="rollback" />
            </div> -->
          </div>
        </div>
        <div v-else-if="isShowSysMsg(item)" :data-id="item.messageId" :class="['customerMessage', 'inService-agent', item.type === '14' ? 'welcome-customerMessage': '']">
          <div v-if="item.type !== '14'" class="avatar">
            <img style="width: 100%; height: 100%" class="visitor-img" :src="config.servicePicture ? config.servicePicture : require('@/assets/img/customer-img.png')"/>
          </div>
          <div v-if="item.type !== '14'" class="cont">
            <div class="name">{{$t('serviceSys')}}</div>
            <msg-content :item="item"></msg-content>
          </div>
          <div v-else style="margin: auto;">
            <msg-content :item="item"></msg-content>
          </div>
        </div>
        <div v-else-if="(item.channelGroupVoList || []).length > 0 && !visitorStatus">
          <group></group>
        </div>
      </template>
    </template>
    <queue v-if="groupStatus === '2'"></queue>
    <!-- 在线回复 -->
    <div class="chat-list" v-if="onlineReplyList && onlineReplyList.length > 0">
      <div class="send-time">{{formattime}}</div>
      <div class="customerMessage" style="margin-top: 0">
        <div class="avatar">
          <img style="width: 100%;height: 100%" class="visitor-img" :src="require('@/assets/img/customer-img.png')"/>
        </div>
        <div class="cont">
          <div class="message-cont">
            <div>
              您有{{onlineReplyList.length}}条新的回复，请点击
              <span @click.stop="checkReply">
                <a v-if="!replyShow">查看</a>
                <a v-else>收起</a>
              </span>
            </div>
            <template v-for="(replyItem, replyIndex) in onlineReplyList">
              <template v-if="replyShow">
                <div style="display: flex;margin: 10px 5px;">[客服回复]: <span v-html="replyItem.replyContent"></span></div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- 正在输入 -->
    <!-- <div class="chat-list inputing" v-if="config.importing === '1' && isCusServiceInput[groupId] && isCusServiceInput[groupId].content === 'INPUT'">
      <div class="customerMessage" style="margin-top: 0">
        <div class="avatar">
          <img style="width: 100%;height: 100%" class="visitor-img" :src="isCusServiceInput[groupId].senderPicture ? isCusServiceInput[groupId].senderPicture : require('@/assets/img/customer-img.png')"/>
        </div>
        <div class="cont">
          <div class="name">{{isCusServiceInput[groupId].senderName}}</div>
          <div class="message-cont">正在输入中...</div>
        </div>
      </div>
    </div> -->
    <!-- 技能组 -->
    <!-- <group v-if="channelGroupVoList.length > 0"></group> -->
    
      <!-- 引用消息--展示区域 [[ -->
      <div :style="{height: showReferenceDetail ? '60px' : '0px', opacity:0}"></div>
      <div class="msg-reference-container" v-if="showReferenceDetail">
        <a-icon type="close-circle" class="icon-close-reference-box" @click="handleCloseReferenceBox"/>
        <dl>
          <dt>{{referenceMessageObj.senderName || referenceMessageObj.senderId}}：</dt>
          <!-- 纯文本 [[ -->
          <dd v-if="referenceMessageObj.contentType == 'text'">
            <div v-html="replaceFace(referenceMessageObj.content)"></div>
          </dd>
          <!-- 纯文本 ]] -->
          <!-- 图片 [[ -->
          <dd v-else-if="referenceMessageObj.contentType == 'image'">
            <div>[{{$t('img')}}]</div>
          </dd>
          <!-- 图片 ]] -->
          <!-- 视频 [[ -->
          <dd v-else-if="referenceMessageObj.contentType == 'video'">
            <div>[{{$t('video')}}]</div>
          </dd>
          <!-- 视频 ]] -->
          <!-- 语音 [[ -->
          <dd v-else-if="referenceMessageObj.contentType == 'voice'">
            <div>[{{$t('voice')}}]</div>
          </dd>
          <!-- 语音 ]] -->
          <!-- 文件 [[ -->
          <dd v-else-if="referenceMessageObj.contentType == 'document'">
            <a :href="referenceMessageObj.content" download target="__blank" style="text-decoration: underline;">{{$t('clickDownload')}} > {{referenceMessageObj.fileName}}</a>
          </dd>
          <!-- 文件 ]] -->
        </dl>
      </div>
      <!-- 引用消息--展示区域 ]] -->
  </div>
</template>
<script>
import ajax from '@/ajax/axios-ajax.js'
import apis from '@/apis/index.js'
import FaceObjConfig from '@/assets/data/faceObjConfig'
import group from './group'
import queue from './queue'
import msgContent from './msg-content'
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex'
export default {
  inject: ['init_socket', 'showLeaveMessage', 'setBaseServiceInfo', 'readVisitorMsg'],
  computed: {
    ...mapState({
      visitorInfo: 'visitorInfo',
      queueStatus: 'queueStatus',
      config: 'config',
      bOnlineVisitor: 'bOnlineVisitor',
      isCusServiceInput: 'isCusServiceInput',
      visitorBasicInfo: 'visitorBasicInfo',
      visitorStatus: 'visitorStatus',
      referenceMessageObj: 'referenceMessageObj'
    }),
    ...mapGetters({
      serviceId: 'serviceId',
      historyServices: 'historyServices',
      groupId: 'groupId',
      groupStatus: 'groupStatus',
      historyServicesIds: 'historyServicesIds'
    })
  },
  data () {
    return {
      chatList: [], //实时聊天记录
      historyList: [], // 历史聊天记录
      chatListItem: [],
      historyPage: {
        pageNum: 0,
        pageSize: 10,
        requestNum: 0,
      },
      scrollHeight: 0,
      isLoading: true,
      loadSuccess: false,
      viewerOption: { // 图片预览插件配置
        navbar: false,
        rotatable: true,
        toolbar: true,
        title: false,
        button: true,
        className: 'customer-viewer-box',
        filter: (image) => { // 表情图片不放大
          return image.className !== 'face-image' && image.className !== 'icon-reference'
        },
        fullscreen: false
      },
      onlineReplyList: [],
      formattime: '',
      replyShow: false,
      showReferenceDetail: false
    }
  },
  methods: {
    ...mapMutations({
      setVisitorInfo: 'setVisitorInfo',
      set_referenceMessage: 'set_referenceMessage'
    }),
    ...mapActions({
      get_queue: 'get_queue',
      transferLabor: 'transferLabor'
    }),
    replaceFace: FaceObjConfig.replaceFace,
    checkReply () {
      let vis = this.$store.state.visitorInfo;
      let params = {
        visitorId: localStorage.newVisitorId || vis.visitorId
      }
      ajax.get(apis.chat.setHasReadvis, {params}).then((res) => {})
      this.replyShow = !this.replyShow
    },
    isShowSysMsg (item) { // 是否显示系统消息
      return (item.category !== 'EVENT' && item.belong === 'system' && (item.display === 'all' || item.display === 'visitor'))
        || (item.category === 'EVENT' && (item.destination === 'all' || item.destination === 'VISITOR'))
    },
    scrollLaod () {
      this.inServiceVisitor()
      if (this.loadSuccess) {
        if (this.$refs.visitorchatBody.scrollTop === 0) {
          this.$message.warn(this.$t('noMoreHistoryLog'))
        }
        return
      }
      if (this.$refs.visitorchatBody.scrollTop === 0) {
        if (this.historyServices.length == 0) {
          return
        }
        if (this.isLoading) {
          this.isLoading = false
          this.scrollHeight = this.$refs.visitorchatBody.scrollHeight
          this.historyMsg()
        } else {

        }
      }
    },
    historyMsg () { // 获得历史聊天记录
      let currentIndex = this.historyPage.pageNum
      let params = {
        serviceId: this.historyServices[currentIndex].serviceId,
        beginTime: this.historyServices[currentIndex].beginTime
      }
      ajax.get(apis.chat.visitorHistoryMsg, {params}).then((res) => {
        if (res.success) {
          let list = res.data || []
          this.chatListItem = list.concat(this.chatListItem)
          this.historyPage.pageNum++
          this.historyPage.requestNum++
          if (this.chatListItem.length < 10 && this.historyPage.pageNum < this.historyServices.length && this.historyPage.requestNum < 5) {
            this.historyMsg()
          } else {
            if (this.historyPage.pageNum == this.historyServices.length) {
              this.loadSuccess = true
            }
            this.historyList = this.chatListItem.concat(this.historyList)
            this.chatListItem = []
            this.historyPage.requestNum = 0
            this.isLoading = true
            this.$nextTick(() => {
              this.$refs.visitorchatBody.scrollTop = this.$refs.visitorchatBody.scrollHeight - this.scrollHeight
            })
          }
        }
      })
    },
    scrollToBottom () { // 页面滚动最底部
      this.$nextTick(() => {
        this.$refs.visitorchatBody.scrollTop = this.$refs.visitorchatBody.scrollHeight
      })
    },
    getServiceMsg () { // 获得实时聊天记录
      let params = {
        tenantId: this.visitorInfo.tenantId,
        serviceId: this.serviceId
      }
      ajax.get(apis.chat.msgInService, {params}).then((res) => {
        if (res.success) {
          this.chatList = this.chatList.concat(res.data || [])
          this.scrollToBottom()
        }
      })
    },
    // 天机实时聊天信息
    push_chatList (item) {
      this.chatList.push(item)
      this.scrollToBottom()
    },
    withdraw (item) {
      console.log(item)
      this.$confirm({
        title: this.$t('confirmRecall'),
        onOk: () => {
          let params = {
            groupId: item.groupId,
            beginTime: item.sendTime,
            serviceId: item.serviceId,
            messageId: item.messageId,
            visitorId: item.senderId,
            tenantId: item.tenantId,
            agentId: item.receiverId
          }
          ajax.get(apis.chat.revokeMessage, { params }).then((res) => {
            const { success, message } = res || {}
            if (success) {
              params.status = -1
            } else {
              this.$message.error(message)
            }
          })

        }
      })
    },
    inServiceVisitor () {
      if (!this.$refs.visitorchatBody) {
        return
      }
      clearTimeout(this.canViewTimeout)
      setTimeout(() => {
        if (!this.$refs.visitorchatBody) {
          return
        }
        let inViList = document.querySelectorAll('.inService-agent')
        let chatContentTop = this.$refs.visitorchatBody.getBoundingClientRect().top
        let chatContentBottom = this.$refs.visitorchatBody.getBoundingClientRect().bottom
        this.canViewMessageId = []
        for (let i = 0; i < inViList.length; i++) {
          let itemTop = inViList[i].getBoundingClientRect().top
          let itemStatus = +inViList[i].getAttribute('data-status')
          if (chatContentTop < itemTop && itemTop < chatContentBottom && itemStatus === 0) {
            this.canViewMessageId.push(inViList[i].getAttribute('data-id'))
          }
        }
        if (this.canViewMessageId.length > 0) {
          let readList = []
          this.chatList.forEach((item) => {
            if (this.canViewMessageId.includes(item.messageId) && item.status === 0) {
              item.status = 1
              readList.push(item.messageId)
            }
          })
          if (readList.length > 0) {
            this.readVisitorMsg(readList)
          }
        }
      }, 600)
    },
    noScrollTop () {
      if (!this.$refs.visitorchatBody) {
        return
      }
      if (this.$refs.visitorchatBody.scrollHeight > this.$refs.visitorchatBody.clientHeight) { } else {
        this.inServiceVisitor()
      }
    },
    queryOnlineReply () {
      let vis = this.$store.state.visitorInfo;
      let params = {
        visitorId: localStorage.newVisitorId || vis.visitorId
      }
      ajax.get(apis.chat.queryOnlineReply, {params}).then((res) => {
        if (res.success) {
          this.onlineReplyList = res.data || []
          this.formatedateTime()
        }
      })
    },
    formatedateTime () { // 格式化时间
      function addZero (num) {
        return (num < 10 ? '0' + num : num)
      }
      let d = new Date()
      this.formattime = d.getFullYear() + '-' + addZero(d.getMonth() + 1) + '-' + addZero(d.getDate()) + ' ' + addZero(d.getHours()) + ':' + addZero(d.getMinutes()) + ':' + addZero(d.getSeconds())
    },
    handleMessageReference (item) {
      this.showReferenceDetail = true
      this.set_referenceMessage(item)
    },
    handleCloseReferenceBox() {
      this.showReferenceDetail = false
      this.set_referenceMessage({})
    }
  },
  mounted () {
    this.queryOnlineReply()
    this.$bus.$on('endChat', msg => {
      let chatList = JSON.parse(JSON.stringify(this.chatList))
      let list = chatList.filter(item => item.type !== '14')
      this.historyList = this.historyList.concat(list)
      this.chatList = []
    })
    this.$bus.$on('socket.message', msg => {
      if (!this.visitorStatus || msg.serviceId === this.serviceId || msg.groupId === this.groupId) {
        this.chatList.push(msg)
        this.scrollToBottom()
        this.noScrollTop()
      }
    })
    // 消息撤回
    this.$bus.$on('socket.revokeMessage',(res) => {
      this.chatList.forEach((ev, index) => {
        if (ev.messageId === res.messageId) {
          ev.status = -1
        }
        if (ev.messageReference && ev.messageReference.refMessageId === res.messageId ) {
          ev.messageReference.refContent = this.$t('meassageHasBeenRevoked')
        }
      })
    })
    this.$bus.$on('socket.agentRead', res => {
      let messageIds = res.messageIds
      this.chatList.forEach((item) => {
        if (messageIds.includes(item.messageId)) {
          item.status = 1
        }
      })
    })
  },
  watch: {
    // groupId: {
    //   deep: true,
    //   handler: function (newVal, oldVal) {
    //     console.log(newVal, 'dsad');
    //   },
    //   immediate: true
    // },
    groupId (val) {
      const channelGroupVoListItem = this.$store.state.channelGroupVoListItem
      if (this.serviceId && channelGroupVoListItem.length > 0) {
        this.getServiceMsg()
      }
      if (this.historyServices.length > 0) {
        this.historyMsg()
      }
    }
  },
  components: {
    group,
    queue,
    msgContent
  },
  beforeDestroy () {
    this.$bus.$off('socket.revokeMessage')
    this.$bus.$off('socket.message')
    this.$bus.$off('endChat')
  }
}
</script>
<style scoped lang="less">
  .chat-list{
    margin-top: 10px;
  }
  .visitor-send-time {
    text-align: right;
  }
  .service-send-time {
    text-align: left;
  }
  .chat-cont {
    height: 500px;
    background-color: #f8fafc;
    padding: 15px 20px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 4px 4px 4px 4px;
      height: 160px;
      background-color: #d4dbe7;
    }
    &::-webkit-scrollbar-button {
      height: 0;
    }
    .sysMessage{
      text-align: center;
    }
    .customerMessage{
      margin-top: 10px;
      display: flex;
      .avatar{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 1px solid #ddd;
        overflow: hidden;
        img {
          border-radius: 50%;
        }
      }
      .cont{
        padding-left: 10px;
        .message-cont{
          max-width: 400px;
          min-height: 30px;
          padding: 6px 10px;
          background: #ffffff;
          margin-top: 5px;
          word-break: break-word;
          border-radius: 8px 0px 8px 8px;
          box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
        }
      }
      .withdraw{
        margin-top: 30px;
        margin-left: 10px;
        color: #b7b5b8;
      }
      
      .icon-reference{
        display: none;
        width: 14px;
        height: 14px;
        margin: 36px 0 0 8px;
        cursor: pointer;
      }
      &:hover{
        .icon-reference{
          display: inline-block;
        }
      }
    }
    .welcome-customerMessage {
      margin-top: 25px;
    }
    .serviceMessage{
      margin-top: 10px;
      display: flex;
      flex-direction: row-reverse;
      .avatar{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 1px solid #ddd;
        img {
          border-radius: 50%;
        }
      }
      .cont{
        padding-right: 10px;
        .name{
          text-align: right;
        }
        .message-cont{
          margin-top: 5px;
          max-width: 400px;
          min-height: 30px;
          padding: 6px 10px;
          border-radius: 5px;
          background-color: rgb(128,194,255);
          word-break: break-word;
          box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
        }
        .have-read{
          text-align: right;
          font-size: 12px;
          color: #b7b5b8;
        }
      }
      .already-withdraw{
        margin-right: 5px;
        padding-top: 5px;
        color: #b7b5b8;
      }
      .withdraw{
        margin-right: 5px;
        padding-top: 5px;
        cursor: pointer;
        color: #b7b5b8;
        display: none;
      }
      .icon-reference{
        display: none;
        width: 14px;
        height: 14px;
        margin: 16px 8px 0 0;
        cursor: pointer;
      }
      &:hover{
        .withdraw{
          display: block;
        }
        .icon-reference{
          display: inline-block;
        }
      }
    }
  }
  .shadow {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  }
  .divider {
    background-color: #bdbaba;
    width: 50%;
    height: 1px;
    margin: 10px auto;
  }
  
  .msg-reference-container{
    width: 100%;
    max-height: 90px;
    position: absolute;
    left: 0;
    bottom: 155px;
    padding: 10px 10px 0 10px;
    background-color: #fff;
    border: 1px solid #e8e8e8;
    dl{
      border-left: 2px solid #0569ff;
      text-indent: 10px;
      font-size: 13px;
      color: #999999;

      dd{
        /deep/p, /deep/div {
          max-height: 40px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .icon-close-reference-box{
      float: right;
      &:hover{
        color: #FF3131;
      }
    }
  }
</style>
